export const PRODUCT_CHAT = 'product_chat';
export const PRODUCT_DASHBOARD = 'product_dashboard';
export const PRODUCT_PAGE = 'product_page';
export const PRODUCT_HISTORY = 'product_history';
export const RFP_PAGE = 'rfp';
